'use strict';

var Logrocket = require("logrocket");

function info(a) {
  
}

function info2(a, b) {
  
}

function info3(a, b, c) {
  
}

function info4(a, b, c, d) {
  
}

function error(a) {
  Logrocket.captureException(a);
  
}

function messageWithData(message, data) {
  Logrocket.captureMessage(message, data);
  
}

function message(message$1) {
  Logrocket.captureMessage(message$1);
  
}

function createError(message) {
  return (new Error(message));
}

var enabled = false;

exports.enabled = enabled;
exports.info = info;
exports.info2 = info2;
exports.info3 = info3;
exports.info4 = info4;
exports.error = error;
exports.messageWithData = messageWithData;
exports.message = message;
exports.createError = createError;
/* logrocket Not a pure module */
